module.exports = __webpack_public_path__ + "img/ar.5bbc8d1d.svg";